import type { FC } from "react";

import classNames from "classnames";

type FlavorFinderResultCardSpecProps = {
  power: number;
  label: string;
};

const maxDots = 5;

export const FlavorFinderResultCardSpec: FC<FlavorFinderResultCardSpecProps> = ({ power, label }) => {
  return (
    <div className="flavorfinder__result-card-spec">
      <span className="spec__title">{label}</span>
      <div className="spec__power">
        <div className="spec__scale">
          {[...Array(maxDots).keys()].map((item) => {
            const isFullActive = item < Math.floor(power);
            const isHalfActive = power - item > 0 && power - item < 1;
            return (
              <span
                key={item}
                className={classNames("spec__dot", {
                  "spec__dot--active": isFullActive,
                  "spec__dot--half": isHalfActive,
                })}
              />
            );
          })}
          <span className="spec__value">{power}</span>
        </div>
      </div>
    </div>
  );
};

export default FlavorFinderResultCardSpec;
